import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RunningClubImage from "../../../../assets/images/running_club.png";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllRunningsClubsAPI,
  joinRunningClubAPI,
} from "../../../../services/rest/runningsClubs/runningClubUser";
import {
  filterRunningClub,
  filterRunningClubDontUser,
  filterRunningClubOfuser,
} from "./filterRunningClubs";
import {
  setAllRunningsClubs,
  setRunningsClubsOfUser,
} from "../../../../redux/slice/runningsClubsSlice";

export default function CardRunningClub({ runningClub, type, setLoading }) {
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { _id, status } = useSelector((state) => state.userReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const joinRunningClub = async (id) => {
    try {
      if (status !== "active" || membershipStatus !== "active") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );

        return;
      }

      setLoading(true);
      // console.log("Id del running club", id);

      await joinRunningClubAPI(id);
      const getAll = await getAllRunningsClubsAPI();
      const runningsClubsOfUser = filterRunningClubOfuser(getAll, _id);
      const AllRunnningClubs = filterRunningClubDontUser(getAll, _id);
      dispatch(
        setAllRunningsClubs({ allRunningsClubs: AllRunnningClubs ?? [] })
      );
      dispatch(
        setRunningsClubsOfUser({ runningsClubsOfUser: runningsClubsOfUser })
      );
      setLoading(false);
      navigate("profile-club", {
        state: { runningClub: runningClub, ofUser: true },
      });
      toast.success(
        `Ahora puede ver las novedades de,${runningClub?.nameCommunity}`
      );
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `¡Algo salió mal! \n
        ${message}`
      );
      // console.log("errror al unirme", error);

      setLoading(false);
    }
  };

  const styleCard = {
    wrapCard: {
      display: "flex",
      maxWidth: 550,
      minHeight: 260,
      borderRadius: 2,
      // backgroundColor: "rgba(212, 216, 216, 0.32)",
      borderRadius: 2,
      gap: 1,
      boxShadow: 3,
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        transform: "scale(1.1)",
        boxShadow: 6,
      },
    },
  };
  return (
    <Card sx={styleCard.wrapCard}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography component="div" variant="h6" textAlign="center">
            {runningClub?.nameRunningClub ?? "Nombre de la comunidad."}
          </Typography>
          <Typography
            variant="subtitle1"
            component="div"
            sx={{ color: "text.secondary", textAlign: "center" }}
          >
            {runningClub?.level ?? "Principiantes"}
          </Typography>
        </CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
            padding: 2,
          }}
        >
          {type === "general" && (
            <Button
              variant="outlined"
              color="#e7ef7d"
              startIcon={<AddIcon />}
              onClick={() => joinRunningClub(runningClub?._id)}
            >
              Unirme
            </Button>
          )}

          <Button
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<RemoveRedEyeIcon />}
            onClick={() => {
              if (status !== "active" || membershipStatus !== "active") {
                toast.error(
                  `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
                );

                return;
              }
              navigate("profile-club", {
                state: { runningClub: runningClub, ofUser: type !== "general" },
              });
            }}
          >
            Ver
          </Button>
        </Box>
      </Box>
      <CardMedia
        component="img"
        sx={{ width: 151 }}
        image={runningClub?.urlImg ?? RunningClubImage}
        alt="Imagen de comunidad"
      />
    </Card>
  );
}
